import { FaHeart } from 'react-icons/fa';
import UserAppContext from '../../hook/UserAppContext';

import './relation.css';

const Relation = () => {

      const {user, dataApp} = UserAppContext()
      const {relation} = user.user
      if(relation.data) return

      return (
            <div className="jd_relation tooltip" data-tooltip={relation.name === '' ? dataApp.relation.name : relation.name}>
                  <div className="jd_relation_avatar">
                        <div className="jd_relation__avatar_box">
                              <img src={relation.avatar === '' ? dataApp.relation.avatar : relation.avatar} alt={relation.name === '' ? dataApp.relation.name : relation.name} />
                        </div>
                  </div>
                  <span>Crush</span>
                  <a href={relation.me === '' ? dataApp.relation.me : relation.me} target="_blank" rel="noreferrer"><p><FaHeart/></p></a>
            </div>
      )
}

export default Relation;